import {useSelector} from "react-redux";
import { RootState} from "../../components/Store";
import { RadioSlider } from "../../components/List/Radio/RadioSlider";
import routes from "../../utils/routes";
import {useQuery} from "@tanstack/react-query";
import {useMyKey} from "../../queriesKeys/useMyKey";
import nextsvg from "../../static/next1.svg";

export const My = () => {
    const current = useSelector((x: RootState) => x.currentUser);
    const { data } = useQuery({ ...useMyKey(1), enabled: !!current })

    if (!data?.count)
        return null;
    return <>
        <RadioSlider title={<>Moje oblíbená {data.count > 10 ? <a href={routes.seznam_radii_moje()}><img src={nextsvg} alt={"další má radia"} /></a>: false}</>} items={data.result} />
        <hr className={"mb-48px mt-48px unmain"}/>
    </>

}